<ion-item [lines]="props['itemLines']">
  <ts-ion-form-field-label-ui [props]="props"></ts-ion-form-field-label-ui>
  <ts-input-field
    [field]="{
      formControl,
      props: getInputFieldProps(),
    }"
  ></ts-input-field>
</ion-item>
<ts-ion-form-field-validation-message-ui
  [field]="field"
  [showError]="showError"
></ts-ion-form-field-validation-message-ui>
<ion-item lines="none">
  <ion-checkbox slot="start" [(ngModel)]="isPasswordShown" labelPlacement="end">
    <ng-container *transloco="let t; scope: 'sharedForm'">
      {{ t('sharedForm.password.show') }}
    </ng-container>
  </ion-checkbox>
</ion-item>
<ts-ion-form-field-help-ui [props]="props"></ts-ion-form-field-help-ui>
